import React from 'react';
import EventHomeLocation from './EventHomeLocation';
import EventHomeSessionSection from './EventHomeSessionSection';
import PrimaryContactBlock from '../../EventLeftHud/PrimaryContactBlock';
import useIsMobileView from "../../../../hooks/useIsMobileView";

export default ({
  eventData = {},
  onReloadData
}) => {
  const isMobileView = useIsMobileView();
  return (
    <div>
      {
        isMobileView &&
        <PrimaryContactBlock eventData={eventData} useSectionStyle={true} />
      }
      <EventHomeLocation eventData={eventData} />
      <EventHomeSessionSection eventData={eventData} onReloadData={onReloadData} />
    </div>
  )
}